import { createSelector } from '@reduxjs/toolkit';
import { selectMultiActFormSelector, selectMultiActReduxFormSelector } from '../selectors';

export const selectMultiActPicture = () => createSelector(selectMultiActFormSelector, (state) => state.multiActPicture);

export const selectMultiActDate = () => createSelector(selectMultiActReduxFormSelector, (state) => state.date);

export const selectMultiActPicturePreviewDisplayed = () =>
  createSelector(selectMultiActFormSelector, (state) => state.picturePreviewDisplayed);
